import LegalLayout from '@/pages/legal/components/LegalLayout';

export default function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="May 2026" current="/terms">
      <p>
        These terms govern your use of the Sapphire Media Group website, our Discord
        server, our Radio platforms (Sapphire Radio, Sapphire Rave), our projects, and any other services we run (collectively, the
        "Services"). By using the Services, you agree to these terms.
      </p>

      <h2>Who we are</h2>
      <p>
        Sapphire Media Group is a youth-led collective, fiscally sponsored by The Hack
        Foundation, a U.S. 501(c)(3) non-profit. Donations to Sapphire are received and
        held by The Hack Foundation on our behalf.
      </p>

      <h2>Using the Services</h2>
      <p>You agree to use the Services lawfully and respectfully. Specifically, you will not:</p>
      <ul>
        <li>Harass, threaten, dox, or impersonate anyone, on or off the Services.</li>
        <li>
          Post content that is illegal, defamatory, sexually explicit, or designed to
          incite violence.
        </li>
        <li>
          Attempt to break, probe, or overload our infrastructure, or to interfere with
          other users' access to it.
        </li>
        <li>
          Use the Services to send spam, run scams, or distribute malware.
        </li>
      </ul>
      <p>
        Conduct in our community spaces (Discord, on-air shows, repos) is also governed by
        our <a href="/code-of-conduct">Code of Conduct</a>.
      </p>

      <h2>Content you submit</h2>
      <p>
        You retain ownership of anything you create and submit to us — code, audio,
        writing, art. By submitting it, you grant Sapphire a non-exclusive, worldwide,
        royalty-free licence to host it, broadcast it, archive it, and use it in
        connection with the Services and our public-facing work, and to credit you for it.
      </p>
      <p>
        Open-source contributions to our public repositories are governed by the licence
        of the repository (typically MIT). When you push a pull request, you certify that
        you have the right to contribute the code under that licence.
      </p>

      <h2>Our content</h2>
      <p>
        The Sapphire name, logo, and marks are ours. Article and show content remains the
        property of its authors and contributors; ask before reposting in full. Open-source
        software we publish is governed by the licence shipped in each repository.
      </p>

      <h2>Donations</h2>
      <p>
        Donations are processed by The Hack Foundation through HCB. They are
        tax-deductible to the extent permitted by U.S. law. Donations are non-refundable
        except where required by law or by HCB's own policies.
      </p>

      <h2>No warranty</h2>
      <p>
        The Services are provided "as is." We do our best to keep them online, accurate,
        and safe, but we make no guarantees about availability, fitness for any
        particular purpose, or the accuracy of content (especially editorial content
        produced by youth contributors and clearly marked as opinion).
      </p>

      <h2>Liability</h2>
      <p>
        To the maximum extent permitted by law, Sapphire Media Group, its volunteers, and
        The Hack Foundation are not liable for indirect, incidental, or consequential
        damages arising out of your use of the Services. Nothing in these terms limits
        liability that cannot be limited by law.
      </p>

      <h2>Termination</h2>
      <p>
        We may suspend or remove your access to the Services if you violate these terms or
        the Code of Conduct, or if continued access poses a risk to the community. You can
        stop using the Services at any time.
      </p>

      <h2>Governing law</h2>
      <p>
        These terms are governed by the laws of the State of California, U.S.A., without
        regard to conflict-of-law principles. Disputes will be heard in the state or
        federal courts located in San Francisco County, California.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms from time to time. The "last updated" date at the top
        reflects the most recent revision. Continued use after a change constitutes
        acceptance.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these terms:{' '}
        <a href="mailto:hello@sapphiremedia.group">hello@sapphiremedia.group</a>.
      </p>
    </LegalLayout>
  );
}
